import Vue, { ComponentOptions } from "vue";
import VueRouter from "vue-router";
import Vuex from "vuex";

/* --- Vue configuration --- */
Vue.use(Vuex);
Vue.use(VueRouter);

import { Scroll } from "./vue-plugins/scroll";

/**
 * Declaring components
 */

import { router } from "./components/router";
import { store } from "./components/store";
import Swipe from "./components/swipe.vue";

import { JSONCarousel } from "./components/json-carousel";
import { DOMCarousel } from "./components/dom-carousel";
import { MainNav } from "./components/mainnav";
import { PanelSearch } from "./components/panel-search";
import { RouterRedirect } from "./components/router-redirect";
import { SpaBreadcrumbs } from "./components/spa-breadcrumbs";
import { SpaHeadline } from "./components/spa-headline";
import { SpaCaseOfNeed } from "./components/spa-caseOfNeed";
import { MapDetails } from "./components/map-details";
import Gmap from "./components/google-maps";
import GMapMultiple from "./components/google-maps-multiple";
import { VueForm } from "./components/vue-form";
import { DetailsRelated, RelatedOverview } from "./components/related";
import LazyMedia from "./components/lazy-media";

import LoadingPage from "./components/loading-page.vue";
import Anim from "./components/anim.vue";
import Anim2 from "./components/anim2.vue";
import Anim3 from "./components/anim3.vue";
import Anim4 from "./components/anim4.vue";
import Anim4Mobile from "./components/anim4-mobile.vue";

import ConditionalFormGroup from "./components/conditional-form-group";

import EventBus from "./helpers/eventbus";
import CookieBanner from './components/cookie-banner.vue';
import TagManager from './components/tag-manager.vue';

import "./css-shell/main.css";
import "./page-styles/main.css";

Vue.use(Scroll, { speed: 50 });

/**
 * Registering Components
 */

Vue.component("lazy-media", LazyMedia);
Vue.component("loading-page", LoadingPage);
Vue.component("frontools-carousel", JSONCarousel as ComponentOptions<Vue>);
Vue.component("dom-carousel", DOMCarousel as ComponentOptions<Vue>);
Vue.component("main-nav", MainNav as ComponentOptions<Vue>);
Vue.component("g-map", Gmap);
Vue.component("g-map-multiple", GMapMultiple);
Vue.component("vue-form", VueForm as ComponentOptions<Vue>);
Vue.component("spa-breadcrumbs", SpaBreadcrumbs as ComponentOptions<Vue>);
Vue.component("spa-headline", SpaHeadline as ComponentOptions<Vue>);
Vue.component("spa-caseofneed", SpaCaseOfNeed as ComponentOptions<Vue>);
Vue.component("panel-search", PanelSearch as ComponentOptions<Vue>);
Vue.component("router-redirect", RouterRedirect as ComponentOptions<Vue>);
Vue.component("map-details", MapDetails as ComponentOptions<Vue>);
Vue.component("details-related", DetailsRelated as ComponentOptions<Vue>);
Vue.component("related-overview", RelatedOverview as ComponentOptions<Vue>);
Vue.component("v-swipe", Swipe);
Vue.component("hero-anim", Anim);
Vue.component("hero-anim2", Anim2);
Vue.component("hero-anim3", Anim3);
Vue.component("hero-anim4", Anim4);
Vue.component("hero-anim4-mobile", Anim4Mobile);
Vue.component("conditional-form-group", ConditionalFormGroup);
Vue.component("cookie-banner", CookieBanner);
Vue.component("tag-manager", TagManager);

/**
 * Instantiating a Vue Instance
 * @type {CombinedVueInstance<V extends Vue, Object, Object, Object, Record<never, any>>}
 */
const datenschutz = {
    template: "<a @click='onClick' class='link'>Datenschutzeinstellungen</a>",
    methods: {
        onClick() {
            EventBus.$emit("openCookieBanner");
        }
    }
};

Vue.component("datenschutz", datenschutz);


const vm = new Vue({
    name: "MainApp",
    el: "#view",
    router,
    store
});

/* --- Filters --- */
Vue.filter("nbToCurrency", (num: string) => Number(num).toLocaleString("de-CH"));
Vue.filter("nbToFloat", (num: string) => parseFloat(num));

/* --- CSS object-fit polyfill --- */
(<any>window).objectFitPolyfill();

vm.$mount("#view");



// WEBPACK FOOTER //
// ./src/main.ts